<osapp-header-modal title="RECHERCHE ARTICLE" toolbarButtonsSlot="end"></osapp-header-modal>

<ion-content>
	<calao-catalog-item-finder (onBarcodeScanValidated)="onBarcodeRead($event)"
		(onManualScanValidated)="onManualScan($event)"></calao-catalog-item-finder>
</ion-content>